module.exports = __webpack_public_path__ + "img/MEG300_Z.aff99de2.png";